import { SourcingList, SourcingSavedSearch } from '../../schemas/SourcingList.schema';
import { ISourcingProfileData, SOURCING_PROFILE_MOCK } from './data/sourcingProfileMockData';

export const PREVIEW_SEARCH_PROMPT = 'Series A fintech companies in the US with ARR over $5M';

const NO_SCHEDULE = {
  refreshScheduleFrequency: null,
  refreshScheduleStartAtUtc: null,
  refreshScheduleTimezone: null,
  refreshScheduleDaysOfWeek: null,
  refreshScheduleDayOfMonth: null,
  enrichScheduleFrequency: null,
  enrichScheduleStartAtUtc: null,
  enrichScheduleTimezone: null,
  enrichScheduleDaysOfWeek: null,
  enrichScheduleDayOfMonth: null,
} as const;

/** A manually managed list, as the live header reads it. */
export const PREVIEW_SOURCING_LIST: SourcingList = {
  ...NO_SCHEDULE,
  id: 'sample-list',
  name: 'Series A Fintech, US',
  entityType: 'company',
  listType: 'static',
  updatedAt: '2026-09-12T10:00:00.000Z',
  lastRefreshDate: null,
  lastEnrichDate: '2026-09-10T08:00:00.000Z',
  enrichScheduleFrequency: 'WEEKLY',
};

/** A saved search that refreshes itself. */
export const PREVIEW_SAVED_SEARCH: SourcingSavedSearch = {
  ...NO_SCHEDULE,
  id: 'sample-search',
  name: 'Vertical SaaS, ARR over $5M',
  entityType: 'company',
  listType: 'active',
  query: PREVIEW_SEARCH_PROMPT,
  lastRefreshDate: '2026-09-15T08:00:00.000Z',
  lastEnrichDate: null,
  refreshScheduleFrequency: 'WEEKLY',
};

/**
 * The repo's mock profile with every identifying field swapped for a fictional company;
 * the traffic, headcount and growth series are kept for their shape.
 */
export const PREVIEW_SOURCING_PROFILE: ISourcingProfileData = {
  ...SOURCING_PROFILE_MOCK,
  id: 'sample-northwind',
  name: 'Northwind Robotics',
  logoUrl: null,
  website: 'northwindrobotics.example',
  description:
    'Northwind Robotics builds autonomous mobile robots for mid-sized warehouses, sold as a subscription with on-site support and fleet software.',
  tags: ['Active', 'Private', 'Startup', 'B2B', 'Robotics'],
  enrichedDate: 'Sep 1, 2026',
  listsCount: 2,
  operationalStatus: 'Operating',
  ceoName: 'Dana Whitfield',
  founders: ['Dana Whitfield', 'Marcus Hale'],
  foundedYear: 2019,
  headcount: '51-200',
  totalRaised: 68_700_000,
  annualRevenue: 14_000_000,
  revenuePerEmployee: 112_000,
  hq: 'Austin, TX',
  sector: ['Robotics'],
  industry: ['Industrial Automation', 'Logistics'],
  keywords: ['warehouse automation', 'autonomous mobile robots', 'fleet software'],
  universe: [],
  linkedinUrl: null,
  twitterUrl: null,
  facebookUrl: null,
  crunchbaseUrl: null,
  pitchbookUrl: null,
  harmonicUrl: null,
  foresightSummary: [
    'Northwind sells warehouse robots on a subscription, so revenue scales with deployed fleet rather than one-off hardware sales.',
    'The Series B in February 2026 was led by Meridian Growth Partners at a $210M post-money valuation.',
  ],
  fundingRounds: [
    {
      stage: 'Series B',
      round: 'Series B',
      date: '2026-02-11',
      raised: 45_000_000,
      postMoney: 210_000_000,
      leadInvestors: ['Meridian Growth Partners'],
      allInvestors: ['Meridian Growth Partners', 'Growth Fund IV', 'Bluewater Capital'],
    },
    {
      stage: 'Series A',
      round: 'Series A',
      date: '2024-06-02',
      raised: 18_000_000,
      postMoney: 72_000_000,
      leadInvestors: ['Growth Fund IV'],
      allInvestors: ['Growth Fund IV', 'Harbor Street Ventures'],
    },
    {
      stage: 'Seed',
      round: 'Seed',
      date: '2023-03-14',
      raised: 4_500_000,
      postMoney: 18_500_000,
      leadInvestors: ['Growth Fund IV'],
      allInvestors: ['Growth Fund IV'],
    },
  ],
  highlights: [
    'Headcount grew 38% over the last twelve months.',
    'Web traffic up 21% quarter over quarter.',
    'Three financing rounds in three years, each led by an institutional investor.',
  ],
  legalName: 'Northwind Robotics, Inc.',
  companyType: 'Private',
  alsoKnownAs: [],
  secondaryHq: null,
  acquiredBy: null,
  keyPeople: [],
  founderPeople: [],
  email: 'hello@northwindrobotics.example',
  phone: null,
  similarCompanies: [],
};
